import { twMerge } from "tailwind-merge";
import Link from "./Link";
import AppButton from "./AppButton";

interface BottomNavigationButtonsProps {
    cancelText?: string;
    confirmText?: string;
    hideCancelButton?: boolean;
    onCancelClick?: () => void;
    onConfirmClick?: () => void;
    confirmPath?: string;
    isCancelDisabled?: boolean;
    isConfirmDisabled?: boolean;
    isConfirmLoading?: boolean;
    isCancelLink?: boolean;
    cancelLinkPath?: string;
    error?: string;
    disclaimerText?: string;
    isFixed?: boolean;
    classes?: {
        root?: string;
    };
}

export default function BottomNavigationButtons({
    cancelText = "Cancel",
    confirmText = "Confirm",
    hideCancelButton = false,
    onCancelClick,
    onConfirmClick,
    confirmPath,
    isCancelDisabled,
    isConfirmDisabled,
    isConfirmLoading,
    cancelLinkPath,
    error,
    disclaimerText,
    isFixed,
    classes = {},
}: BottomNavigationButtonsProps) {
    return (
        <div
            className={twMerge(
                `flex gap-2 mt-2`,
                disclaimerText
                    ? "justify-between flex-row items-center"
                    : "justify-end",
                isFixed && "items-center isBottomPanel",
                classes.root
            )}
        >
            {disclaimerText ? (
                <span className="w-full text-red-error text-base xl:text-xl font-semibold">
                    {disclaimerText}
                </span>
            ) : null}
            <div
                className={twMerge(
                    "flex gap-2 flex-col",
                    isFixed && "flex-row-reverse items-center gap-5"
                )}
            >
                <div
                    className={`${
                        !disclaimerText && !isFixed ? "w-full" : ""
                    } flex gap-2 justify-end items-center`}
                >
                    {cancelLinkPath ? (
                        <Link
                            to={cancelLinkPath}
                            onClick={onCancelClick}
                            className="btn-outline-primary w-40 xl:w-[200px]"
                        >
                            <span className="w-full">{cancelText}</span>
                        </Link>
                    ) : (
                        !hideCancelButton && (
                            <AppButton
                                type="button"
                                onClick={onCancelClick}
                                className="w-40 xl:w-[200px]"
                                disabled={isCancelDisabled || isConfirmLoading}
                                variant="outlined"
                            >
                                <span className="w-full">{cancelText}</span>
                            </AppButton>
                        )
                    )}
                    {confirmPath ? (
                        <Link
                            onClick={onConfirmClick}
                            to={confirmPath}
                            className="btn-primary w-40 xl:w-[200px] h-full"
                            disabled={isConfirmDisabled}
                        >
                            {confirmText}
                        </Link>
                    ) : (
                        <AppButton
                            onClick={onConfirmClick}
                            className="w-40 xl:w-[200px] h-full"
                            type="button"
                            disabled={isConfirmDisabled}
                            loading={isConfirmLoading}
                        >
                            {confirmText}
                        </AppButton>
                    )}
                </div>
                {error ? <span className="text-red-error">{error}</span> : null}
            </div>
        </div>
    );
}
